/**
 * Расположение
 */
export enum TirPmModalAlignEnum {
  /**
   * Справа
   */
  Right = "right",
  /**
   * По центру (дефолт)
   */
  Center = "center",
}
